import { ApiClient } from './client.js'
import { SFX_PSE_SEARCH, SFX_PSE_DOWNLOAD } from './resources.js'

const client = new ApiClient()

export default {
  searchPseSfx (data) {
    return client.post(SFX_PSE_SEARCH, data)
  },

  downloadPseSfx (sfxId) {
    return client.post(SFX_PSE_DOWNLOAD, { id: sfxId })
  }
}
